import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { NativeStorage } from "@ionic-native/native-storage/ngx";

import { Platform } from "@ionic/angular";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class BaseService {
  httpClientHeaders: HttpHeaders;
  BASE_URL: string;

  constructor(
    protected httpClient: HttpClient,
    protected platform: Platform,
    protected storage: NativeStorage
  ) {
    this.BASE_URL = environment.BASE_API_URL;
  }

  private async getAngularHeaders() {
    const token = localStorage.getItem('ms_token') || undefined;

    this.httpClientHeaders = new HttpHeaders();
    this.httpClientHeaders = this.httpClientHeaders.append(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );
    if (token) {
      this.httpClientHeaders = this.httpClientHeaders.append(
        "Authorization",
        token
      );
    }
  }
  private proccessResponse(data: any): any {
    let p = new Promise((onSuccess, onError) => {
      switch (data.status) {
        case "ERROR":
          if (data.error.message.includes("tokenError")) {
            console.log("ERROR", data.error);
            break;
          } else {
            onError(this.handleError(data.error));
            break;
          }
        case "OK":
          onSuccess(data.data);
          break;
        default:
          onError(new Error("Invalid Response From Server: " + data.status));
          break;
      }
    });
    return p;
  }
  private handleError(error: any) {
    error.message = "Error de conexión con el servidor. Servicio no encontrado";
    return error;
  }

  public async post(_url, args): Promise<any> {
    try {
      await this.getAngularHeaders();
      let _args = "arg=" + encodeURIComponent(JSON.stringify(args));
      let data = await this.httpClient
        .post(_url, _args, { headers: this.httpClientHeaders })
        .toPromise();
      let response = await this.proccessResponse(data);
      return response;
    } catch (error) {
      throw error;
    }
  }

  public isMobilePlatform(): boolean {
    return this.platform.is("hybrid");
  }
}
